import { render, staticRenderFns } from "./EditNotificationModal.vue?vue&type=template&id=96a88536&scoped=true"
import script from "./EditNotificationModal.vue?vue&type=script&lang=js"
export * from "./EditNotificationModal.vue?vue&type=script&lang=js"
import style0 from "./EditNotificationModal.vue?vue&type=style&index=0&id=96a88536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a88536",
  null
  
)

export default component.exports